import {
  TableCell,
  TableRow as MuiTableRow
} from '@mui/material'
import { RenderValue }    from 'components/render'
import { useTranslator } from 'hooks/translator';

export default function TableRow({row, columns, index, section, rowAction}) {
  return (
    <MuiTableRow 
      sx={row.rowProps || {}}
      id={"row_" + index}
      gears-id={row.id}
      //onContextMenu={handleContextMenu}
      onClick={row.onClick}          
      style={{cursor: row.onClick ? 'pointer' : undefined}}
      hover
      key={index}
    >
      <DataRow columns={columns} row={row} section={section} rowAction={rowAction}/>
      {/*<TableRowMenu menu={menu} contextMenu={contextMenu} setContextMenu={setContextMenu}/>*/}
    </MuiTableRow>
  )
}

const DataRow = ({row, columns, section, rowAction}) => {
  const { translator } = useTranslator()

  function makeDataCell(column, index) {
    const isLabel = column.field == 'label'
    const isList = (section?.kind || section?.type) == 'list'

    const baseSx = isLabel || isList ? {} : {whiteSpace: "normal", wordWrap: "break-word"}
    const displayProps = column.field == 'label'
      ? column.displayProps
      : row.displayProps || column.displayProps
    const value = _.get(row, "cells." + column.field)
    const translatedValue = section ? translator.toListValue(section.key, value) : value

    return (
      <TableCell key={index} {...column.cellProps} >
        <RenderValue section={section} sx={{ ...baseSx, ...row.rowProps }} displayProps={displayProps}>
          {translatedValue}
        </RenderValue>
      </TableCell>
    )
  }

  return columns.map((column, index) => rowAction && column.field === '__action'
    ? <TableCell key={index} {...column.cellProps}>{rowAction(row)}</TableCell>
    : makeDataCell(column, index)
  )
}
